import Repository from "@shared/services/api/abstracts/Repository";
import { PublicInvoiceDetailSerializer } from "../types/invoice";

export default class PublicBasedInvoiceRepository extends Repository<PublicInvoiceDetailSerializer> {
  public readonly repositoryName = "PublicBasedInvoiceRepository";

  public readonly endpoint = "/api/public/financials/invoice/";
}
